import React, { useEffect } from "react";
import { Form, useFormField } from "@redriver/cinnamon";
import RegistrationLabel from "./RegistrationLabel";
import { OrganisationsSubForm } from "components/forms";

const OrganisationsItem = ({ item }) => {
  const [organisations, setOrganisations] = useFormField(item.id);

  useEffect(() => {
    // initialise with a single item when first shown
    if (!organisations?.length) {
      setOrganisations([{ id: Date.now(), isPrimary: true, isPublic: true }]);
    }
  }, []);

  return (
    <div className="organisations-registration-item">
      <Form.Field
        required={item.required}
        label={
          <RegistrationLabel label={item.label} subHeader={item.subHeading} />
        }
      />
      <OrganisationsSubForm
        field={item.id}
        infoText={item.infoText}
        showPublic
        publicLabel="Available to others"
        publicWidth={115}
        organisationRequired
        positionRequired
        allowAdditions
      />
    </div>
  );
};

export default OrganisationsItem;
